


var myconfig = {
    rootUrl: process.env.REACT_APP_ROOTURL,
    appVersion: process.env.REACT_APP_VERSION,
}


export default myconfig;